import Vuex from 'vuex';

const state = {
  currentMediaQueryName: ''
};

const getters = {
  getCurrentMediaQueryName: (state, getters, rootState) => {
    return state.currentMediaQueryName;
  },
  currentMediaQuery: state => state.currentMediaQueryName
};

const actions = {
  updateMediaQueryName: ({ state, commit }, mediaQueryName) => {
    commit('changeMediaQueryName', { mediaQueryName })
  }
};

const mutations = {
  changeMediaQueryName: (state, { mediaQueryName }) => {
    state.currentMediaQueryName = mediaQueryName
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./store/modules/mediaqueries.js